import packageJson from '../../package.json' assert { type: 'json' };

(() => {
  console.log('buildVersions', packageJson.buildVersions);
  document.addEventListener("DOMContentLoaded", () => {
    const versions = document.createElement('div');
    versions.id = 'buildVersions';
    versions.dataset.js = packageJson.buildVersions?.js;
    versions.dataset.css = packageJson.buildVersions?.css;
    versions.style = `
      position: fixed;
      top: 2px;
      right: 2px;
      font-size: 7px;
      opacity: 0.25;
      z-index: 10000;
    `;
    versions.innerHTML = `
      <span id="ver-js">js ${packageJson.buildVersions?.js}</span>
      <span id="ver-css">css ${packageJson.buildVersions?.css}</span>
    `;

    document.body.append(versions);
  })
})();
